/* eslint-disable react/self-closing-comp */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from './PendingBAR.module.css';
import  PendingBookingApprovalReport  from '../../components/PendingBookingApprovalReport/PendingBookingApprovalReport';

import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

function BookingApprovalReport({product}) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push('/home');
  };


  return (
    <>
      <div className={styles.container} style={{ boxSizing: 'border-box' }}>
          <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToProcessPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Report" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar} style={{}}>

          <UserInfoPanel
                userInfo={[
                  {
                    Name: "Rutuja",
                    "SAP ID": 122366,
                    "BC No": "122366",
                    LOC: "Research Center",
                  },
                ]}
              />
              </div>
 </div>
     
        <PendingBookingApprovalReport redirectToProcessPage={redirectToProcessPage}/>

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
BookingApprovalReport.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(BookingApprovalReport); 
